///////////////////////////////////////////////////////////////////////////////////////
//                          Copyright (c) 2020 - 2020
//                           Coyote Logistics L.L.C.
//                         All Rights Reserved Worldwide
//
//WARNING:  This program (or document) is unpublished, proprietary
//property of Coyote Logistics L.L.C. and is to be maintained in strict confidence.
//Unauthorized reproduction, distribution or disclosure of this program
//(or document), or any program (or document) derived from it is
//prohibited by State and Federal law, and by local law outside of the U.S.
///////////////////////////////////////////////////////////////////////////////////////

import React from "react";

import messages from "../../helpers/messages";

export const Close = ({
  height,
  fill = "#FB0225",
  secondaryFill = "#FFD7CC",
  title = messages.close.defaultMessage,
  width,
  ...props
}) => {
  return (
    <svg
      aria-labelledby="close-icon"
      height={height}
      viewBox="0 0 24 24"
      width={width}
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <title id="check">{title}</title>
      <path
        fill={fill}
        d="M16.5 8.406l-.906-.906L12 11.094 8.406 7.5l-.906.906L11.094 12 7.5 15.594l.906.906L12 12.906l3.594 3.594.906-.906L12.906 12z"
      />
    </svg>
  );
};

export default Close;
